import {
  ButtonVariants,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import * as React from 'react';

import '../../style/confirm-modal.less';

export type PropsT = {
  isShown: boolean;
  confirm: () => void;
  cancel: () => void;
  headline: string | JSX.Element;
  text?: string | JSX.Element;
  cancelText?: string;
  confirmText: string;
  confirmVariant?: ButtonVariants;
  confirmProps?: React.ComponentProps<typeof ModalFoot>['confirmProps'];
  children?: React.ReactElement;
};

/**
 * @deprecated Use the app modal action instead to implement confirm modals.
 *
 *   See more about working with modals in the [Contribution
 *   Guidelines](https://www.notion.so/dixa/React-8fabb11b8add431eb438299af7817c24#25c574589e834dab85ab3cc76fe1de0f).
 * @example
 *   const handleDelete = async () => {
 *     const { isConfirmed } = await dispatch(
 *       appActions.showModal({
 *         modal: {
 *           type: 'app:confirm',
 *           arg: {
 *             title: `Delete thing`,
 *             description: 'Are you sure you want to delete the thing?',
 *             confirm: {
 *               label: 'Delete',
 *             },
 *           },
 *         },
 *       }),
 *     );
 *
 *     if (isConfirmed) {
 *       try {
 *         await deleteThing();
 *
 *         notify(
 *           {
 *             title: 'Thing deleted successfully.',
 *             icon: 'i-done',
 *             time: 5000,
 *           },
 *           NotificationType.Success,
 *         );
 *       } catch (error) {
 *         notify(
 *           {
 *             title: 'Something went wrong deleting the thing.',
 *           },
 *           NotificationType.Error,
 *         );
 *       }
 *     }
 *   };
 */
export class ConfirmModal extends React.Component<PropsT> {
  static defaultProps = {
    confirmProps: {},
  };

  render() {
    const {
      confirm,
      cancel,
      isShown,
      headline,
      text,
      cancelText,
      confirmText,
      confirmVariant,
      confirmProps,
      children,
    } = this.props;

    if (!isShown) return null;

    return (
      <Modal isOpen={isShown} onClose={cancel}>
        <ModalHead title={headline as string} onClose={cancel} />
        <ModalBody>
          {text && <div className="confirm-modal__body">{text}</div>}
          {children}
        </ModalBody>
        <ModalFoot
          confirmOnClick={confirm}
          cancelOnClick={cancel}
          cancelName={cancelText}
          confirmName={confirmText}
          confirmProps={{
            variant: confirmVariant || 'danger',
            ...confirmProps,
          }}
        ></ModalFoot>
      </Modal>
    );
  }
}
